import { usersAPI } from '@/api'
import { ApiResult } from '@modals/RequiredEmailConfirmation/components/RequiredEmailConfirmationModal/utils/api'
import { CancelTokenSource } from 'axios';

export interface ISeminarianDirection {
  direction_id: number
  id: number
  rate: number
  rate_group: number
  seminarian_id: number
}

export const getSeminarianDirections = async (
  id: number,
  cancelTokenSource?: CancelTokenSource
): Promise<
  ApiResult<
    ISeminarianDirection[]
  >
> => {
  try {
    const res = await usersAPI.directionBySeminarian({
      id: id,
      params: {}, //{ expand: 'direction.directionGroups,seminarian' }
    }, cancelTokenSource)

    // const success = res?.data?.status === 'success' ||

    return {
      data: res?.data?.data || res?.data,
      success: !!res?.data?.data,
      error:
        res?.data?.error || res?.data?.message || 'Ошибка получения данных',
    }
  } catch (error) {
    console.error('Ошибка fetchFileFromFileMedia:', error)
    return {
      data: null,
      success: false,
      error: error instanceof Error ? error.message : String(error),
    }
  }
}
